import { useCallback, useState, useMemo } from "react";
import { NotificationsContext } from "../notifications-context";
import { NotificationsList } from "../notifications";
import {
  NotificationId,
  NotificationConfig,
  NotificationContent,
} from "../notifications-context/types";
import { Portal } from "../../common/components/portal";
import { getNotificationsPortalContainer } from "./utils";
import {
  NotificationsProviderProps,
  NotificationsProviderState,
} from "./types";
import "./styles.global.scss"; // TODO: Добавить лоадер для обработки глобальных стилей в Storybook

export const NotificationsProvider = ({
  children,
}: NotificationsProviderProps) => {
  const [notifications, setNotifications] =
    useState<NotificationsProviderState>([]);

  const removeNotification = (notificationId: NotificationId) => {
    setNotifications((notifications) =>
      notifications.filter(
        (notification) => notification.notificationId !== notificationId
      )
    );
  };

  const closeNotification = useCallback((notificationId: NotificationId) => {
    setNotifications((notifications) =>
      notifications.map((notification) => {
        if (notification.notificationId === notificationId) {
          return { ...notification, visible: false };
        }

        return notification;
      })
    );
  }, []);

  const openNotification = useCallback(
    (content: NotificationContent, config: NotificationConfig = {}) => {
      const notificationId = (new Date().getTime() +
        Math.random()) as NotificationId;

      setNotifications((notifications) => [
        ...notifications,
        {
          config,
          content,
          visible: true,
          notificationId,
          closeNotification,
          removeNotification,
        },
      ]);

      return notificationId;
    },
    [closeNotification]
  );

  const contextValue = useMemo(
    () => ({
      openNotification,
      closeNotification,
    }),
    [closeNotification, openNotification]
  );

  return (
    <NotificationsContext.Provider value={contextValue}>
      <Portal getContainer={getNotificationsPortalContainer}>
        <NotificationsList notifications={notifications} />
      </Portal>
      {children}
    </NotificationsContext.Provider>
  );
};
